import {
  ApiBlueprint,
  FrontendPlugin,
  PageBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { AuditApiClient } from './api/AuditApiClient';
import { auditApiRef } from './api/auditApiRef';
import { rootRouteRef } from './routes';

const auditApi = ApiBlueprint.make({
  name: 'service-catalog-audit',
  params: define =>
    define({
      api: auditApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AuditApiClient({ discoveryApi, fetchApi }),
    }),
});

const serviceCatalogAuditPage = PageBlueprint.make({
  name: 'service-catalog-audit',
  params: {
    path: '/service-catalog-audit',
    title: 'Audit [Service Catalog]',
    icon: <AssignmentTurnedInIcon />,
    routeRef: rootRouteRef,
    loader: () =>
      import(
        './components/ServiceCatalogAuditPage/ServiceCatalogAuditPage'
      ).then(m => <m.ServiceCatalogAuditPage />),
  },
});

const serviceCatalogAuditPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'service-catalog-audit',
  routes: { root: rootRouteRef },
  extensions: [auditApi, serviceCatalogAuditPage],
});

export default serviceCatalogAuditPlugin;
